import {
  Measure
} from '../common/measure';
import {
  DIM2CLASS
} from '../core/icon-class';

require('./filter-drilldown-draggable.component.scss');

class FilterDrillDownDraggableController {
  constructor(
    $scope,
    CurrentFilterService,
    RouterService,
    CurrentModelService,
  ) {
    this.$scope = $scope;
    this.getMeasure = Measure.getMeasure;
    this.getMeasureLabel = Measure.getMeasureLabel;
    this.getMeasures = Measure.getMeasures;
    this.DIM2CLASS = DIM2CLASS;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.CurrentFilterService.rebuildVisibleDimensions();
  }

  selectDim(dim) {
    if (this.router.isFilterEditModal) {
      if (this.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.filter.addDrilldown(dim.toString());
      // this.filter.changed();
      this.$onChanges(this);
    } else this.router.selectDim(dim);
  }

  setMeasure(measure) {
    if (this.router.isFilterEditModal) this.filter.measure = measure;
    else this.router.setMeasure(measure);
  }

  removeDim(dim) {
    if (this.router.isFilterEditModal) {

      if (!this.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.filter.removeDrilldown(dim.toString());
      this.$onChanges(this);
      // this.filter.changed();
      // this.filterChanged();
    } else this.router.removeDim(dim);
  }

  get showRemove() {
    const drillList = this.$scope.list.filter(item => item.isDrill);
    return drillList && drillList.length > 1;
  }

  get test() {
    // console.log(this);
    return true;
  }

  get visibleDimensions() {
    return this.CurrentFilterService.visibleDimensions;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  // toggleSortDrillSorterOrder(drill) {
  //   const filter = this.filterData.filter;
  //   if (!filter.orders || !filter.orderDirs) {
  //     filter.orders = [];
  //     filter.orderDirs = [];
  //   }
  //   if (!filter.hasOwnProperty('orders')) {
  //     filter.orders = angular.copy(filter.orders);
  //   }
  //   if (!filter.hasOwnProperty('orderDirs')) {
  //     filter.orderDirs = angular.copy(filter.orderDirs);
  //   }
  //
  //   const columnName = this.getOrderColumnName(drill);
  //   if (!filter.orders.includes(columnName)) {
  //     filter.orders.push(columnName);
  //     filter.orderDirs.push(columnName.split(',').map(o => 'asc').join(','));
  //     // filter.orderDirs.push('asc');
  //   } else {
  //     const sortIndex = this.getOrderDirIndex(drill);
  //     const sortDir = this.getSortDir(drill);
  //     if (sortDir === 'desc') {
  //       filter.orders.splice(sortIndex, 1);
  //       filter.orderDirs.splice(sortIndex, 1);
  //     } else {
  //       filter.orderDirs[sortIndex] = 'desc';
  //     }
  //   }
  //   filter.orders = angular.copy(filter.orders);
  //   filter.orderDirs = angular.copy(filter.orderDirs);
  //
  //   if (this.router.isFilterEditModal) this.filterData.update(filter);
  //   else this.router.filter = filter;
  // }

  toggleSortDirs(columnName) {
    const colOrders = columnName.split(',');
    const filter = this.filterData.filter;
    for (let i = 0; i < filter.orders.length; i++) {
      let j = 0;
      if (colOrders.every(o => {
          const res = o === filter.orders[i + j];
          j++;
          return res;
        })) {
        const dir = filter.orderDirs[i];
        if (dir === 'asc') {
          colOrders.map((o, j) => filter.orderDirs[i + j] = 'desc');
        } else {
          filter.orders.splice(i, colOrders.length);
          filter.orderDirs.splice(i, colOrders.length);
        }
      }
    }
  }

  toggleSortDrillSorterOrder(drill) {
    const filter = this.filterData.filter;
    if (!filter.orders || !filter.orderDirs) {
      filter.orders = [];
      filter.orderDirs = [];
    }
    if (!filter.hasOwnProperty('orders')) {
      filter.orders = angular.copy(filter.orders);
    }
    if (!filter.hasOwnProperty('orderDirs')) {
      filter.orderDirs = angular.copy(filter.orderDirs);
    }

    const columnName = this.getOrderColumnName(drill);
    if (filter.orders.join(',').indexOf(columnName) === -1) {
      filter.orders = filter.orders.concat(columnName.split(','));
      filter.orderDirs = filter.orderDirs.concat(columnName.split(',').map(o => 'asc'));
    } else {
      this.toggleSortDirs(columnName);
    }
    filter.orders = angular.copy(filter.orders);
    filter.orderDirs = angular.copy(filter.orderDirs);

    if (this.router.isFilterEditModal) this.filterData.update(filter);
    this.router.filter = filter;
  }

  toggleSortMeasureSorterOrder() {
    const filter = this.filterData.filter;
    if (!filter.hasOwnProperty('orders')) {
      filter.orders = angular.copy(filter.orders);
    }
    if (!filter.hasOwnProperty('orderDirs')) {
      filter.orderDirs = angular.copy(filter.orderDirs);
    }

    const columnName = 'measure';
    if (!filter.orders.includes(columnName)) {
      filter.orders.push(columnName);
      filter.orderDirs.push('asc');
    } else {
      const sortIndex = this.getMeasureOrderDirIndex();
      const sortDir = this.getMeasureSortDir();
      if (sortDir === 'desc') {
        filter.orders.splice(sortIndex, 1);
        filter.orderDirs.splice(sortIndex, 1);
      } else {
        filter.orderDirs[sortIndex] = 'desc';
      }
    }
    filter.orders = angular.copy(filter.orders);
    filter.orderDirs = angular.copy(filter.orderDirs);

    if (this.router.isFilterEditModal) this.filterData.update(filter);
    else this.router.filter = filter;

  }

  // isSortable(drill) {
  //   const columnName = this.getOrderColumnName(drill);
  //   const filter = this.filterData.filter;
  //   return filter.orders && filter.orders.includes(columnName);
  // }
  isSortable(drill) {
    const columnName = this.getOrderColumnName(drill);
    const filter = this.filterData.filter;
    return filter.orders && filter.orders.join(',').includes(columnName);
  }


  isMesureSortable() {
    const filter = this.filterData.filter;
    const columnName = 'measure';
    if (!filter) {
      return false;
    }
    return filter.orders && filter.orders.includes(columnName);
  }

  getSortDir(drill) {
    const sortIndex = this.getOrderDirIndex(drill);
    return this.filterData.filter.orderDirs[sortIndex];
  }

  getMeasureSortDir() {
    const sortIndex = this.getMeasureOrderDirIndex();
    if (sortIndex === -1) {
      return null;
    }
    return this.filterData.filter.orderDirs[sortIndex];
  }

  // getOrderDirIndex(drill) {
  //   const filter = this.filterData.filter;
  //   const columnName = this.getOrderColumnName(drill);
  //   const sortIndex = filter.orders.findIndex(e => e === columnName);
  //   return sortIndex;
  // }

  getOrderDirIndex(drill) {
    const filter = this.filterData.filter;
    const columnOrders = this.getOrderColumnName(drill).split(',');

    const sortIndex = filter.orders.findIndex((e, i) =>
      columnOrders.every((o, j) => filter.orders[i + j] === columnOrders[j]));
    return sortIndex;
  }

  getMeasureOrderDirIndex() {
    const filter = this.filterData.filter;
    const columnName = 'measure';
    if (!filter) {
      return -1;
    }
    const sortIndex = filter.orders.findIndex(e => e === columnName);
    return sortIndex;
  }

  getOrderColumnName(drill) {
    const dimension = this.CurrentModelService.model.getDimensionParts(drill);
    if (
      dimension.hierarchy.name === 'ym' ||
      dimension.hierarchy.name === 'ymd' ||
      dimension.hierarchy.name === 'ymdh' ||
      dimension.hierarchy.name === 'ymdhm'
    )
      return dimension.hierarchy.levels.map(l => `${dimension.dimension.name}.${l}`).join(',');
    return `${dimension.dimension.name}.${dimension.level.label_attribute}`;
  }

  dropMove(index) {
    this.$scope.list.splice(index, 1);
    const filter = this.filter;
    filter.drilldown = [];
    const newDrills = this.$scope.list.filter(item => item.isDrill).map(item => item.key);
    filter.drilldown.splice(0, filter.drilldown.length, ...newDrills);
    if (this.router.isFilterEditModal) this.filterData.update(filter);
    else this.router.filter = filter;
  }

  $onChanges(changesObj) {
    const currentValue = this.router.isFilterEditModal ? this.filter : changesObj.filter.currentValue;
    if (changesObj.filter && currentValue) {

      const newDrillsList = currentValue.drilldown.slice().map(item => {
        return {
          key: item,
          label: this.model.getDrillLabel(item),
          isDrill: true,
        };
      });
      const staticItems = [{
          isDrill: false
        },
        {
          isDrill: false
        }
      ];
      this.$scope.list = staticItems.concat(newDrillsList);
    }
  }
}

export const FilterDrillDownDraggableComponent = {
  template: require('./filter-drilldown-draggable.component.html'),
  bindings: {
    filter: '<',
    filterData: '<',
  },
  scope: {
    list: [],
  },
  controller: FilterDrillDownDraggableController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-drilldown-draggable.component.js